/* eslint-disable no-nested-ternary */

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Navbar, NavbarBrand, Card, CardFooter, CardBody, CardText, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageTitle, Button } from '@cordata/buffet';

import Identity from '~/assets/identity.svg';

import { authorizedInstance as axios } from '~/utils';

const OptOut = () => {
  const { token } = useParams();
  const [status, setStatus] = useState(false);

  const optOut = () => {
    setStatus('loading');

    axios
      .post(`/public/engagements/opt-out/${token}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('danger'));
  };

  return (
    <>
      <Navbar color="primary" dark expand="md" className="mb-3 sticky-top" style={{ height: '56px' }}>
        <NavbarBrand>
          <img src={Identity} width={130} alt="Navigator - Cordata" className="mr-2" />
        </NavbarBrand>
      </Navbar>

      <Container>
        {status &&
          <Alert color={status === 'loading' ? 'info' : status}>{
            status === 'success'
              ? 'You successfully opted out.'
              : status === 'danger'
                ? 'Something went wrong.'
                : status === 'info'
                  ? 'You\'ve cancelled this action.'
                  : 'Working ...'
            }
          </Alert>
        }

        <PageTitle>Engagement Opt-out</PageTitle>

        <Card>
          <CardBody>
            <CardText>Are you sure you want to opt out of engagements?</CardText>
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="cancel"
                onClick={() => setStatus('info')}
                disabled={status}
              >
                Cancel
              </Button>

              <Button
                color="primary"
                onClick={optOut}
                disabled={status}
              >
                <FontAwesomeIcon icon="check" />
                <span className="d-none d-md-inline ml-2">Confirm opt out</span>
              </Button>
            </div>
          </CardFooter>
        </Card>
      </Container>
    </>
  );
};

export default OptOut;
